<div
  class="oi-container"
  [class.oi-focus]="isFocus"
  [class.oi-has-value]="hasValue"
  [class.oi-disabled]="isDisabled"
  [ngClass]="classByState()"
>
  <label
    [attr.for]="inputId"
    [class.stacked]="labelStacked"
    *ngIf="label"
    (click)="key.setFocus()"
    (keypress)="true"
    >{{ label }}</label
  >
  <ion-icon
    class="icon-eye"
    role="button"
    tabindex="0"
    *ngIf="showIcon()"
    [name]="tempType !== 'text' ? 'eye-off' : 'eye'"
    (click)="tempType = tempType === 'text' ? 'password' : 'text'"
    (keypress)="true"
  >
  </ion-icon>
  <ion-input
    #key
    class="oi-input"
    [ngModel]="value"
    [type]="tempType"
    [minlength]="minlength"
    [maxlength]="maxlength"
    [autocomplete]="autocomplete"
    (ionFocus)="onFocus()"
    (ionBlur)="onBlur()"
    (ionInput)="onChange($event)"
    [disabled]="isDisabled"
    (keypress)="(true)"
    [readonly]="isReadOnly"
  >
  </ion-input>
  <span class="error-message" *ngIf="showError()">
    {{ errorMessage }}
  </span>
</div>
